<template>
    <div>
        <div class="about_top_parent">
            <img class="top_img" src="@/assets/img/about/about_bg.png"/>
            <div class="about_top_desc">
                <div class="about_top_desc_title">招聘信息</div>
                <div class="about_top_desc_title" style="margin-top: 10px;font-family: PingFangSC-Light, PingFang SC;">简历投递：hr@miitang.com</div>
            </div>
        </div>
        <div class="des_title">员工福利</div>
        <div class="des_hint">加入我们团队，实现自我价值，工作生活两不误</div>
        <div class="title_line"/>
        <div style="display: flex;flex-direction: row;width:100%;margin-top: 60px;">
            <div class="benefit_item">
                <img class="benefit_img" src="@/assets/img/about/invite_base.png"/>
                <div class="small_title">基本保障</div>
                <div class="small_title_line"/>
                <div class="small_desc">五险一金全额最高比例缴纳<br/>工作居住证办理</div>
            </div>
            <div class="benefit_item">
                <img class="benefit_img" src="@/assets/img/about/invite_health.png"/>
                <div class="small_title">健康保障</div>
                <div class="small_title_line"/>
                <div class="small_desc">员工和子女补充医疗<br/>每年免费体检</div>
            </div>
            <div class="benefit_item">
                <img class="benefit_img" src="@/assets/img/about/invite_life.png"/>
                <div class="small_title">有闲生活</div>
                <div class="small_title_line"/>
                <div class="small_desc">团建聚玩乐、温馨下午茶、节假<br/>小惊喜，生日小礼物……</div>
            </div>
            <div class="benefit_item">
                <img class="benefit_img" src="@/assets/img/about/invite_holiday.png"/>
                <div class="small_title">休假福利</div>
                <div class="small_title_line"/>
                <div class="small_desc">生日假、入职日假、春节路途<br/>假、结婚纪念日假、带薪年假7<br/>天天起……</div>
            </div>
        </div>
        <div class="des_title">职位信息</div>
        <div class="title_line"/>
        <div style="margin-top:50px;margin-left:80px;margin-right:80px;height:auto;background: #F2F6FF;padding: 48px">
            <div style="font-size: 28px;font-family: PingFangSC-Light, PingFang SC;font-weight: 300;color: #3A404D;line-height: 40px;">客户经理</div>
            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">岗位职责：</div>
            <div style="margin-top:16px;">1、独立完成行业客户的拓展，完成销售任务目标；
                <br/>2、负责刷脸支付行业解决方案在客户业务中的策划、报价及关键环节的把控，做好项目过程中监控执行，确保项目落地；</div>

            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">任职要求：</div>
            <div style="margin-top:16px;font-family: PingFangSC-Regular, PingFang SC;">1、具有3年以上销售经验，掌握销售技巧和大客户洽谈流程；有社区电商、游戏、视频聊天、行政缴费及支付行业工作经验者优先；
                <br/>2、了解该行业相关知识，有顾问式销售经验，有客户资源者优先考虑；
                <br/>3、严防底线，善于思考，较强的商务沟通、策划和公关协调能力；
                <br/>4、良好的表达能力及团队合作能力；
                <br/>5、有非常强的目标导向，对客户有同理心，能快速识别客户需求，能根据客户需求提出产品优化建议</div>
        </div>

        <div style="margin:30px 80px 10px;height:auto;background: #F2F6FF;padding: 48px">
            <div style="font-size: 28px;font-family: PingFangSC-Light, PingFang SC;font-weight: 300;color: #3A404D;line-height: 40px;">销售代表</div>
            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">岗位职责：</div>
            <div style="margin-top:16px;">1、负责公司刷脸产品及行业支付解决方案的销售，维护原有客户关系并拓展新的销售商机；
                <br/>2、定期拜访客户，搜集有效信息并分析客户需求，提出初步解决方案；
                <br/>3、与客户维持良好的关系，做好客户定期回访工作。</div>

            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">任职要求：</div>
            <div style="margin-top:16px;">1、本科及以上学历，市场营销、工商管理、计算机、软件工程等相关专业优先考虑；
                <br/>2、2年以上彩票CRM系统开发商相关销售工作经验；
                <br/>3、拥有强烈的开拓进取精神和抗压能力，热爱销售事业，勤奋、踏实、有韧性。</div>
        </div>

        <div style="margin:30px 80px 70px;height:auto;background: #F2F6FF;padding: 48px 48px 48px 48px">
            <div style="font-size: 28px;font-family: PingFangSC-Light, PingFang SC;font-weight: 300;color: #3A404D;line-height: 40px;">JAVA开发工程师</div>
            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">岗位职责：</div>
            <div style="margin-top:16px;">1、负责云平台的核心系统的研发；
                <br/>2、参与项目的架构与方案设计，能提出优化和改进的建议并实施落地；
                <br/>3、对初级技术人员进行技术指导。</div>

            <div style="margin-top:16px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #3A404D;line-height: 28px;">任职要求：</div>
            <div style="margin-top:16px;">1、JAVA基础扎实，有良好的编码习惯；
                <br/>2、精通io、多线程、集合等基础框架，对JVM原理有深入的了解；
                <br/>3、3年及以上使用JAVA开发的经验，熟悉spring、MyBatis、maven、Tomcat等常用工具和框架，对其运行原理有较好的理解；
                <br/>4、有大规模高并发互联网应用的设计和开发经验，熟悉常规的分布式架构，熟悉缓存、消息队列等开源中间件；
                <br/>5、熟悉系统架构设计，能对常见问题进行合理的架构设计，保证系统的性能指标；
                <br/>6、有支付行业从业经验者优先；
                <br/>7、有带小团队经验者优先考虑。</div>
        </div>
    </div>

</template>
<script>
    export default {
        name: "Invite"
    }
</script>

<style scoped>

    .about_top_parent {
        position: relative;
        height: 340px;
    }

    .top_img {
        position: absolute;
        width: 100%;
        height: 340px;
    }

    .about_top_desc {
        width: 100%;
        height: 340px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
    }

    .about_top_desc_title {
        align-self: center;
        font-size: 45px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2F2D2D;
    }

    .des_title{
        text-align: center;
        width: 100%;
        font-size: 40px;
        font-family: PingFangSC-Thin, PingFang SC;
        font-weight: 100;
        color: #000000;
        line-height: 56px;
        margin-top: 40px;
    }

    .des_hint{
        text-align: center;
        width: 100%;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3A404D;
        line-height: 28px;
        margin-top: 16px;
    }

    .title_line {
        width: 100px;
        height: 4px;
        background: #4183D7;
        margin-left: auto;
        margin-top: 16px;
        margin-right: auto;
    }

    .benefit_item {
        width: 40px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    .small_title {
        font-size: 28px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #3A404D;
        line-height: 40px;
        margin-top: 16px;
        align-self: center;
    }

    .small_title_line {
        width: 100px;
        height: 4px;
        margin-top: 6px;
        background: #4183D7;
        align-self: center;
    }

    .small_desc {
        text-align: center;
        margin-top: 12px;
        font-size: 14px;
        margin-left: 20px;
        margin-right: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #000000;
        line-height: 20px;
        align-self: center;
    }

    .benefit_img{
        align-self: center;
        width: 120px;
        height: 120px;
    }
</style>